<script>
    import { onMount, onDestroy } from 'svelte';
    import { fade } from 'svelte/transition';

    import api from '../api';
    import Upload from '../components/upload.svelte';
    import { traerProductos } from './productos/_productos.svelte';
    import { comoMoneda } from '../utils';

    let facturas = [];
    let cancelandoFactura = {};

    $: facturas,
        (cancelandoFactura = Object.fromEntries(
            facturas.map(({ num_factura }) => [num_factura, false])
        ));

    async function cancelarFactura(id) {
        await api.patch(`facturas/${id}/cancelar/`);
        traerFacturas();
    }

    async function subirFactura(factura) {
        const formData = new FormData();
        formData.append('factura', factura);
        await api.post('facturas/desde_archivo/', formData);
        traerFacturas();
    }

    async function traerFacturas() {
        const result = await api.get('facturas/');
        facturas = [...result.data];
    }

    function sumValues(arr, key) {
        return arr.reduce((acc, obj) => acc + obj[key], 0);
    }

    onMount(traerFacturas);
    onDestroy(traerProductos);
</script>

<div class="pb-2 m-6">
    <div class="mb-4 mr-4">
        <Upload accept=".pdf" on:archivo="{evt => subirFactura(evt.detail)}">
            <div class="text-center uppercase">
                Selecciona o suelta una factura aquí para crearla
            </div>
        </Upload>
    </div>
    {#each facturas as { num_factura, fecha, compras, total, ganancia } (num_factura)}
        <div class="relative mb-4 border rounded" transition:fade>
            {#if cancelandoFactura[num_factura]}
                <div
                    class="absolute top-0 bottom-0 left-0 right-0 flex flex-col items-center justify-center bg-white rounded"
                    transition:fade
                >
                    <div>
                        ¿Segura que quieres cancelar la compra
                        <span class="font-bold">{num_factura}</span>
                        ?
                    </div>
                    <div class="flex mt-4">
                        <button
                            class="mr-4"
                            on:click="{() => (cancelandoFactura[num_factura] = false)}"
                        >
                            Regresar
                        </button>
                        <button
                            variant="error"
                            on:click="{() => cancelarFactura(num_factura)}"
                        >
                            Cancelar
                        </button>
                    </div>
                </div>
            {/if}
            <div class="flex p-2 px-3 bg-gray-100 border-b rounded-t">
                <div>{fecha.slice(0, 10)}</div>
                <div class="px-3">|</div>
                <div class="font-bold">{num_factura}</div>
                <i
                    class="ml-auto rounded cursor-pointer material-icons"
                    variant="error"
                    on:click="{() => (cancelandoFactura[num_factura] = true)}"
                >
                    clear
                </i>
            </div>
            <div class="m-3">
                <table class="border">
                    <thead>
                        <tr>
                            <td>Cantidad</td>
                            <td>Producto</td>
                            <td>Precio Unitario</td>
                            <td>Descuento</td>
                            <td>Costo (+ IVA)</td>
                        </tr>
                    </thead>
                    {#each compras as { producto, cantidad, precio, total, costo, descuento, ganancia }}
                        <tr>
                            <td class="text-right">{cantidad}</td>
                            <td>{producto}</td>
                            <td class="text-right">{comoMoneda(precio)}</td>
                            <td class="text-right">{descuento * 100}%</td>
                            <td class="text-right">{comoMoneda(costo)}</td>
                        </tr>
                    {/each}
                    <tr class="font-bold">
                        <td colspan="4">Total</td>
                        <td class="text-right">
                            {comoMoneda(sumValues(compras, 'costo'))}
                        </td>
                    </tr>
                </table>
            </div>
        </div>
    {/each}
</div>
